<template>
  <div class="multiple-upload">
    <v-dialog v-model="value" persistent max-width="800">
      <v-card>
        <v-card-title class="ma-0">
          <v-spacer />
          <v-btn icon small :loading="loading" @click="handleCancel"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex v-for="(video, index) in videos" :key="`video_${index}`" xs4 md3 lg2 d-flex>
              <v-card flat class="d-flex">
                <v-card-text>
                  <div style="border-radius: 10px; border: 1px solid #eeee; position: relative">
                    <video width="200" controls>
                      <source :src="video.url" type="video/mp4" />
                      <source :src="video.url" type="video/mov" />
                    </video>

                    <div
                      style="position: absolute; right: 0px; top: 0px"
                      @click="handleDeleteImage(index)"
                    >
                      <v-btn icon><v-icon>delete</v-icon></v-btn>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <template v-if="videos.length < maxLength && !loading">
            <div
              class="text-xs-center imageBtn"
              :class="{ dropover: isDropover }"
              @click="onAddImage"
              @dragover="onDragover"
              @dragleave="onDragleave"
              @drop="onDrop"
            >
              <v-layout justify-center align-center row style="height: 100%" class="py-4 px-2">
                <div class="text-xs-center">Click to upload or drag Video to here</div>
              </v-layout>
            </div>
          </template>
          <div
            v-if="videos.length > 5"
            class="mt-3"
            :style="{
              color: 'red'
            }"
          >
            *กรณีตอบกลับภายใน 20 นาที หากแอดมินหรือแชทบอทยังไม่ได้ทำการตอบกลับลูกค้า
            การส่งรูปภาพและVDO มากกว่า 5 ไฟล์ต่อ 1 ครั้งในครั้งแรก จะไม่เสียค่าข้อความ (Push
            message) และทุกๆ 5 ไฟล์ถัดไปถูกคิดค่าข้อความเป็น 1 (Push message)
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" outline :loading="loading" @click="handleCancel">{{
            $t('cancel')
          }}</v-btn>
          <v-btn color="primary" depressed :loading="loading" @click="handleSend">
            {{ $t('Send') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <input
      id="videoUploadInput"
      type="file"
      accept="video/mp4, video/mov"
      multiple
      style="
        height: 0px;
        width: 0px;
        visibility: hidden;
        position: fixed;
        margin-left: -999px;
        left: 0;
      "
      @input="onFileChange($event)"
    />
  </div>
</template>

<script>
import api from '@/api'
const events = ['dragenter', 'dragover', 'dragleave', 'drop']

import FileUpload from 'vue-upload-component'
export default {
  components: {
    FileUpload
  },
  props: { value: {}, maxLength: { default: 100 } },
  data() {
    return {
      videos: [],
      singleImage: null,
      isDropover: false,
      loading: false
    }
  },
  computed: {},
  mounted() {
    events.forEach((eventName) => {
      document.body.addEventListener(eventName, this.preventDefaults)
    })
  },
  beforeDestroy() {
    events.forEach((eventName) => {
      document.body.removeEventListener(eventName, this.preventDefaults)
    })
  },
  methods: {
    onAddImage() {
      document.getElementById('videoUploadInput').click()
    },
    onFileChange() {
      const files = event.target.files || event.dataTransfer.files
      this.addVideoIntoArray([...files])
    },
    async handleSend() {
      const vm = this
      if (vm.videos.length === 0) {
        await vm.$swal.fire({
          title: 'Upload at least one video',
          type: 'error'
        })
      } else {
        vm.loading = true
        const files = vm.videos
        const resizeFiles = await Promise.all(
          files.map(async (obj) => {
            return {
              ...obj,
              file: obj.file
            }
          })
        )

        vm.loading = false
        vm.videos = []
        vm.$emit('input', false)

        const s3url = await Promise.all(
          resizeFiles.map(async (obj) => {
            return { ...obj, s3Url: await vm.createVideo(obj.file) }
          })
        )

        const messages = s3url.map((obj) => {
          return { source: obj.s3Url, type: 'video' }
        })

        vm.$emit('handleSendVideos', {
          messages: messages,
          onComplete: function () {
            vm.$emit('input', false)
          }
        })
      }
    },
    handleCancel() {
      this.videos = []
      this.$emit('input', false)
    },
    uploadImages() {},
    onDragover(e) {
      e.preventDefault()
      this.isDropover = true
    },
    onDragleave(e) {
      this.isDropover = false
    },
    onDrop(e) {
      e.preventDefault()
      const files = [...e.dataTransfer.files]
      this.addVideoIntoArray(files)
    },
    addVideoIntoArray(files) {
      const videos = files.filter((file) => {
        const type = file.type.toLowerCase()
        return type == 'video/mp4' || type == 'video/mov'
      })

      if (videos) {
        const videoWithUrl = videos.map((video) => {
          return {
            file: video,
            url: URL.createObjectURL(video)
          }
        })
        const spliceImages = [...this.videos, ...videoWithUrl]
        this.videos = spliceImages.slice(0, this.maxLength)
      }
    },
    handleDeleteImage(index) {
      this.videos.splice(index, 1)
    },
    async createVideo(file) {
      try {
        return await this.upload(file)
      } catch (error) {
        this.$swal({
          title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
          type: 'error',
          text: `upload: ${error}`,
          confirmButtonText: this.$t('Confirm')
        })
      }
    },
    upload(file) {
      let data = {
        name: file.name,
        type: file.type,
        file: file
      }
      let vm = this
      return new Promise((resolve, reject) => {
        api.getSignedRequest(data, function (error, url) {
          if (error) {
            reject(error)
          }

          url = encodeURI(url)

          vm.currentImage = url
          // vm.$emit('input', vm.currentImage, { width: vm.tempWidth, height: vm.tempHeight })
          if (vm.multiple) {
            vm.multiplefile.push(vm.currentImage)
            if (vm.filelength == vm.multiplefile.length) {
              vm.$emit('onUploaded', vm.multiplefile)
            }
          } else {
            vm.$emit('onUploaded', vm.currentImage)
          }
          resolve(vm.currentImage)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.imageBtn {
  height: 80px;
  border: 3px dashed #eee;
  border-radius: 10px;
  cursor: pointer;
  &:hover {
    background: #eee;
  }
  &.dropover {
    background: #eee;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/UploadMultipleVideo/UploadMultipleVideo.vue